"use strict";
exports.__esModule = true;
exports.FieldValidators = void 0;
var email_1 = require("./email");
var name_1 = require("./name");
var notKeyword_1 = require("./notKeyword");
var numeric_1 = require("./numeric");
var numericPositive_1 = require("./numericPositive");
var required_1 = require("./required");
exports.FieldValidators = { email: email_1.email, name: name_1.name, notKeyword: notKeyword_1.notKeyword, numeric: numeric_1.numeric, numericPositive: numericPositive_1.numericPositive, required: required_1.required };
//# sourceMappingURL=index.js.map